import React, { useEffect, useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Layout } from "src/components/layout"
import { SIDE_MENU, SNACKBAR_TYPES } from "src/modules/const"
import { useNavigate, useParams } from "react-router"
import { validateField } from "src/modules/validation"
import { useAuth } from "src/providers/LoginProvider"
import { TagService } from "src/openapi"
import { ShowToast } from "../../states/showToast"
import { ShowProgress } from "../../states/showProgress"
import { useRecoilState } from "recoil"
import { TagDeleteModal } from "./TagDeleteModal"
import InputTextField from "src/components/atom/InputTextField"
import BreadCrumb from "src/components/atom/BreadCrumb"
import * as yup from "yup"
import "./index.scss"
import { Top } from "../top"

export const TagEdit = () => {
  const { t } = useTranslation("translation", { keyPrefix: "tag" })

  const [tag, settag] = useState<string>("")

  const navigate = useNavigate()

  const { user } = useAuth()

  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [tagValidationMessage, setTagValidationMessage] = useState<string>("")

  const { companyId, id } = useParams()
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false)

  const checkValidation = async () => {
    let valid = true
    valid = valid && tag != ""

    try {
      await validateField(
        yup.object().shape({
          tag: yup.string().required(t("please_input_tag_name")).max(20, t("tag_length_max")),
        }),
        "tag",
        tag
      )
      setTagValidationMessage("")
    } catch (err: any) {
      setTagValidationMessage(err.message)
      valid = valid && false
    }

    return valid
  }

  const handleUpdate = async () => {
    if (!(await checkValidation())) {
      return
    }

    if (user == null) {
      return
    }

    setShowProgress(true)

    TagService.updateTag(parseInt(companyId!), parseInt(id!), { tag: tag }, user.token)
      .then(() => {
        setShowProgress(false)
        setShowToast({
          show: true,
          text: t("success_update_tag"),
          type: SNACKBAR_TYPES.SUCCESS,
        })
        navigate(`/company/${companyId}/tag`)
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_update_tag"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  const handleGetTag = async () => {
    if (user == null) {
      return
    }
    setShowProgress(true)
    TagService.getTag(user.token, parseInt(companyId!), parseInt(id!))
      .then((res) => {
        setShowProgress(false)
        settag(res.tag!)
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_get_tag"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  const handleDelete = () => {
    if (user == null) {
      return
    }

    setShowProgress(true)

    TagService.deleteTag(user.token, parseInt(companyId!), parseInt(id!))
      .then(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("success_delete"), type: SNACKBAR_TYPES.SUCCESS })
        navigate(`/company/${companyId}/tag`)
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_delete"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  useEffect(() => {
    if (user == null) {
      return
    }
    handleGetTag()
  }, [user, companyId, id])

  if (!user) {
    return <Top />
  }

  return (
    <Layout menu={SIDE_MENU.TAG_LIST}>
      <BreadCrumb
        paths={[
          {
            name: t("list_title"),
            link: `/company/${companyId}/tag`,
          },
          {
            name: t("edit_title"),
            link: "",
          },
        ]}
      />
      <Typography className="tag-register-description">{t("edit_description")}</Typography>
      <Box className="tag-content-container">
        <Box className="tag-item-container">
          <Box className="tag-item-title">{t("tag_name")}</Box>
          <Box className="tag-item-content-container">
            <InputTextField
              text={tag}
              handleText={settag}
              inputStyle={{ width: "300px", height: "54px" }}
              placeholder={t("tag_name")}
              validationMessage={tagValidationMessage}
            />{" "}
          </Box>
        </Box>
      </Box>
      <Typography className="remove-button-container" onClick={() => setDeleteModalOpen(true)}>
        {t("delete")}
      </Typography>
      <Button
        className="tag-register-button"
        sx={{
          width: "200px!important",
          backgroundColor: "#46F3C4",
        }}
        onClick={() => handleUpdate()}
      >
        {t("update_tag")}
      </Button>
      <Button
        className="tag-back-button"
        sx={{ width: "200px" }}
        onClick={() => navigate(`/company/${companyId}/tag`)}
      >
        {t("back")}
      </Button>

      <TagDeleteModal
        open={deleteModalOpen}
        handleOpen={setDeleteModalOpen}
        handleDelete={handleDelete}
      />
    </Layout>
  )
}
